<template>
  <div class="md-layout-item md-size-100 md-medium-size-100">
    <md-card>
      <md-card-header
        class="md-card-header-icon"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          SafeCore Guidebook
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-medium-size-100">
            <h3>SafeCore GPR Marking & Communication System Guidebook</h3>
            <p>The SafeCore GPR (Ground Penetrating Radar) Marking and Communication System Guidebook is designed to educate GPR technicians, contractors and facility personnel on the SafeCore Systems application methods and options. The guidebook outlines how the system is designed to improve jobsite safety by reducing the inherent risks and hazards of GPR scanning, cutting, coring, anchoring and demolition. It is recommended that all users review the guidebook in its entirety prior to utilizing the system.</p>
            <md-button @click="openContent" class="md-info">Download</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
  export default {
    data(){

    },
    methods: {
      openContent(){
        // this.downloadClicked = true;
        window.open("https://drive.google.com/file/d/1U0hDec0_7kldFwhK30xkZUEjMCoyhElg/view?usp=sharing", '_blank')
      }
    }
  }
</script>
<style media="screen" lang="scss">
</style>
